import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { Validators } from '@angular/forms';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import { CommonPagesService } from 'src/@shared/common-pages.service';
import { InnerPagesService } from 'src/app/pages/common-layout/inner-pages.service';
import { ResponseStatus, RoleType, UserType, UserTypes, ValidationMessage } from '../../enum';
import { stripHiddenNameSuffix } from '../../utils/visibility-display-name.util';

interface AccountInfo {
  id: string;
  accountName: string;
  isSelected?: boolean;
}
interface SupplierInfo {
  id: string;
  name: string;
  isSelected?: boolean;
}
@Component({
  selector: 'app-add-update-user',
  templateUrl: './add-update-user.component.html',
  styleUrls: ['./add-update-user.component.scss'],

  standalone: false,
})
export class AddUpdateUserComponent implements OnInit {
  dropdownList: any[] = [];
  accountsData: any[] = [];
  selectedItems: any[] = [];
  sitesData: any = [];
  supplierBankSitesData: any = [];
  isVisibleUserDrawer = true;
  isLoadingOne: any = false;
  userDrawerTitle: any = 'Add New User';
  @Output() hideUserDrawer = new EventEmitter();
  @Input() selectedData: any;
  @Input() listOfRoles: any;
  @Input() currentSelectedTab: any;
  selectedusers: any[] = [];
  passwordVisible = false;
  // listOfRoles: any[] = [];
  isTwoFA: any;
  listOfAgencies: any[] = [];
  selectedAgencyData: any[] = [];
  arrayOfAgency: any[] = [];
  listOfSites: any[] = [];
  siteArray: any[] = [];
  usersArray: any[] = [];
  nodes: any[] = [];
  currentUserDetails: any;
  selectedAccounts: any[] = [];
  selectedSites: any[] = [];
  /** Supplier Bank sites — kept separate so the Account and Sites tree cannot overwrite them. */
  sbSelectedSites: any[] = [];
  selectedSupplierData: any[] = [];
  showAccountsInvalidMessage: boolean = false;
  showSitesInvalidMessage: boolean = false;
  showAgencysInvalidMessage: boolean = false;
  showSuppliersInvalidMessage: boolean = false;
  show2FAToggle: boolean = false;
  validationMessage = ValidationMessage
  accountsArrayToPass: AccountInfo[] = [];
  /** Supplier Bank accounts — kept separate so the Account and Sites tree cannot overwrite them. */
  sbAccountsArrayToPass: AccountInfo[] = [];
  disableAccountsAndSites: boolean = false;
  isLoadingAccountSites: boolean = false;
  isLoadingSupplierReps: boolean = false;
  @ViewChild('phoneNumberField') phoneNumberField: any;
  @ViewChild('agencySelect') agencySelect: any;
  @ViewChildren('supplierSelect') supplierSelect: any;
  @ViewChildren('supplierBankSelect') supplierBankSelect: any;
  currentSelectedAccounts: any;
  currentSelectedSBAccounts: any;
  supplierAndRepsData: any[] = [];
  currentSelectedRepsSupplier: any;
  selectedReps: any[] = [];
  repsToBePassed: any[] = [];
  suppliersArrayToPass: SupplierInfo[] = [];
  retailProgramsList: any[] = [];
  showRepsInvalidMessage: boolean = false;
  hasPermissionToPrograms: boolean = false;

  constructor(
    public _cS: CommonService,
    private _cpS: CommonPagesService,
    public _fS: FormService,
    private _iS: InnerPagesService
  ) {
    _fS.userForm_fb();
  }

  get UserTypes() {
    return UserTypes;
  }

  /** List of assigned accounts with their sites for display under the Account and Sites dropdown */
  get assignedAccountsSitesList(): { accountName: string; sites: { name: string }[] }[] {
    if (!this.currentSelectedAccounts?.length) return [];
    return this.currentSelectedAccounts
      .filter(
        (item: any) =>
          item.parent?.checked || (item.children || []).some((c: any) => c.checked)
      )
      .map((item: any) => ({
        accountName: item.parent?.name ?? '',
        sites: (item.children || [])
          .filter((c: any) => c.checked)
          .map((c: any) => ({ name: c.name })),
      }))
      .filter((item: any) => item.accountName);
  }

  /** List of assigned suppliers with their reps for display under the Supplier and Reps dropdown */
  get assignedSupplierRepsList(): { parentName: string; children: { name: string }[] }[] {
    if (!this.currentSelectedRepsSupplier?.length) return [];
    return this.currentSelectedRepsSupplier
      .filter(
        (item: any) =>
          item.parent?.checked || (item.children || []).some((c: any) => c.checked)
      )
      .map((item: any) => ({
        parentName: item.parent?.name ?? '',
        children: (item.children || [])
          .filter((c: any) => c.checked)
          .map((c: any) => ({ name: c.name })),
      }))
      .filter((item: any) => item.parentName);
  }

  /** List of assigned supplier bank accounts with their sites for display under the Supplier Bank dropdown */
  get assignedSupplierBankList(): { accountName: string; sites: { name: string }[] }[] {
    if (!this.currentSelectedSBAccounts?.length) return [];
    return this.currentSelectedSBAccounts
      .filter(
        (item: any) =>
          item.parent?.checked || (item.children || []).some((c: any) => c.checked)
      )
      .map((item: any) => ({
        accountName: item.parent?.name ?? '',
        sites: (item.children || [])
          .filter((c: any) => c.checked)
          .map((c: any) => ({ name: c.name })),
      }))
      .filter((item: any) => item.accountName);
  }

  selectedProgarmIds: any[] = [];

  ngOnInit(): void {
    //get roles from db for dropdown
    // if (this.currentSelectedTab != UserTypes.Supplier) {
    this.getAllAgencys();
    // }

    if (this.currentSelectedTab == UserTypes.Supplier) {
      this.getRetailProgramForSupplier();
    }

    if (this.selectedData != null) {
      this.userDrawerTitle = 'Edit User (' + this.selectedData.firstName + ')';
      this._fS.userForm.patchValue({
        firstName: this.selectedData.firstName,
        lastName: this.selectedData.lastName,
        emailAddress: this.selectedData.email,
        role: this.selectedData.role,
        isUserActive: this.selectedData.isActive,
        phoneNumber: this.selectedData.phoneNumber,
        is2FArequired: this.selectedData.twoFactorEnabled,
        agency: this.selectedData.agency,
        accounts: this.selectedData.accounts,
        sites: this.selectedData.sites,
        isChangePasswordRequired: this.selectedData.isForcePasswordChange,
        supplierReps: this.selectedData.suppliers || [],
      });
      this.checkIfPayBevRole(this.selectedData.role);
      this._fS.userForm.controls['emailAddress'].disable();

      this.agencyDropdownChanged(this.accountsData, 'PATCH');
      // if (this.currentSelectedTab != UserTypes.Supplier) {
      this.accountsArrayToPass = this.selectedData.accounts;
      this.selectedSites = this.selectedData.sites;
      // Fallback for the Supplier tab: SBsitesDropdownChanged replaces these as soon as
      // the Supplier Bank tree loads, so this only matters if that load never happens.
      // Copies, so the Account and Sites rebuild cannot mutate them through selectedData.
      this.sbAccountsArrayToPass = [...(this.selectedData.accounts ?? [])];
      this.sbSelectedSites = [...(this.selectedData.sites ?? [])];
      // }else{
      this.selectedSupplierData = this.selectedData.suppliers || [];
      // }

      if (this.selectedData && this.selectedData.roles == 'Super Admin') {
        // disable role dropdown
        this._fS.userForm.controls['role'].disable();
      } else {
        this._fS.userForm.controls['role'].enable();
      }

      // Disable "Account and Sites" for protected roles.
      const rolesValue = this.selectedData?.roles;

      const rolesLower = rolesValue.toLowerCase();
      this.disableAccountsAndSites =
        rolesLower.includes('super admin') || rolesLower.includes('accountant');

    } else {
      this.userDrawerTitle = 'Add New User';
      this.agencyDropdownChanged(this.accountsData, 'GET');
      // this.agencyDropdownChanged(this.accountsData, 'GET');
    }

    if (this.currentSelectedTab == UserTypes.Supplier) {
      this.getAllSuppliersDropdown();
    }

    this.listOfRoles = this.listOfRoles.filter(
      (x: any) => x.roleType == this.currentSelectedTab
    );

    if (this.currentSelectedTab == UserTypes.Supplier && !this.selectedData?.localSupplier) {
      //make supplierReps field required
      this._fS.userForm.controls['supplierReps'].setValidators([Validators.required]);
      //updateValueAndValidity
      this._fS.userForm.controls['supplierReps'].updateValueAndValidity();
    }
  }

  checkIfPayBevRole(event: any) {
    var selectedRole = this.listOfRoles.find((role: any) => role.id == event);
    if (selectedRole) {
      if (selectedRole.roleType == RoleType.Operator || selectedRole.roleType == RoleType.Supplier) {
        this.show2FAToggle = true;
        setTimeout(() => {
          this.phoneNumberField.nativeElement.focus();
        });
      } else {
        this.show2FAToggle = false;
      }
    }
  }

  checkIf2FAEnabled(event: any) {
    if (event) {
      this._fS.userForm.controls['phoneNumber'].addValidators([
        Validators.required,
      ]);
      if (!this._fS.userForm.get('phoneNumber').value)
        this._fS.userForm.controls['phoneNumber'].setErrors({
          incorrect: true,
        });
    } else {
      this._fS.userForm.get('phoneNumber').clearValidators();
      this._fS.userForm.controls['phoneNumber'].setErrors(null);
    }
    this._fS.userForm
      .get('phoneNumber')
      .updateValueAndValidity({ onlySelf: true });
    event ? (this.isTwoFA = true) : (this.isTwoFA = false);
  }

  retailProgramsChange(event: any, data: any) {
    data.isChecked = event;
  }

  //close drawer
  handleCancel() {
    this.isVisibleUserDrawer = false;
    this.hideUserDrawer.emit({ hide: this.isVisibleUserDrawer, data: null });
  }

  agencyDropdownChanged(event: any, type: any) {
    this.isLoadingAccountSites = true;
    this._cpS
      .GetSiteByAccount(this.currentSelectedTab)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.sitesData = response.result;
          // Mark hidden sites in the dropdown based on API status.
          // `gs-select` renders `child.name`, so we suffix the name here.
          this.sitesData?.forEach((parent: any) => {
            const isParentHidden = parent?.parentStatus === 0;
            if (isParentHidden && parent?.parent && !parent.parent.includes('(hidden)')) {
              parent.parent = `${parent.parent} (hidden)`;
            }

            parent?.children?.forEach((child: any) => {
              const isHidden =
                child?.status === 0;
              if (isHidden && child?.name && !child.name.includes('(hidden)')) {
                child.name = `${child.name} (hidden)`;
              }
            });
          });
          if (this.currentSelectedTab == UserTypes.Supplier) {
            let tmpSitesData = this.sitesData;
            this.sitesData = tmpSitesData.filter((site: any) => {
              return site.children[0].accountAgencyType == 1;
            });

            this.supplierBankSitesData = tmpSitesData.filter((site: any) => {
              return site.children[0].accountAgencyType != 1;
            });

            if (type == 'PATCH') {
              var count = 0;
              this.selectedData.sites.forEach((el: any) => {
                this.supplierBankSitesData.map((parentelement: any) => {
                  parentelement.children.map((childelement: any) => {
                    if (el.id == childelement.id) {
                      childelement.checked = true;
                      childelement.search = true;
                    }
                  });
                });
              });
              this.supplierBankSitesData.map((parentelement: any) => {
                parentelement.children.map((childelement: any) => {
                  if (childelement.checked == true) {
                    count++;
                  }
                });
                // if (count == parentelement.children.length) {
                parentelement['parent'] = {
                  name: parentelement.parent,
                  id: parentelement.children[0].accountId,
                  search: true,
                  checked: false,
                };
                // } else {
                // parentelement['parent'] = {
                //   name: parentelement.parent,
                //   id: parentelement.children[0].accountId,
                //   search: true,
                //   checked: false,
                // };
                // }
              });
              this.selectedData.accounts.forEach((element: any) => {
                if (element.isSelected == true) {
                  //if any child is checked then parent should be checked
                  if (element.children?.some((child: any) => child.checked)) {
                    this.supplierBankSitesData.map((item: any) => {
                      if (item.parent.id == element.id) {
                        item.parent.checked = true;
                      }
                    });
                  }
                  this.supplierBankSitesData = [...this.supplierBankSitesData];
                }
              });

              // if (this.currentSelectedTab == UserTypes.Supplier) {
              //   this.supplierBankSitesData.forEach(({ parent, children }) => {
              //     // find any children that are checked === true
              //     const checkedChildren = children.filter(
              //       (child) => child.checked
              //     );

              //     // if parent is checked, or if any child is checked...
              //     if (parent.checked || checkedChildren.length > 0) {
              //       // …add the parent…
              //       this.repsToBePassed.push(parent);
              //       // …and add all those checked children
              //       this.selectedReps.push(...checkedChildren);
              //     }
              //   });
              // }
            } else if (type == 'GET') {
              this.supplierBankSitesData.map((el: any, i: any) => {
                el.children.map((e: any) => {
                  {
                    e.search = true;
                    e.checked = false;
                  }
                });
                el['parent'] = {
                  name: el.parent,
                  id: el.children[0].accountId,
                  search: true,
                  checked: false,
                };
              });
            }
            this.SBsitesDropdownChanged(this.supplierBankSitesData);
          }

          if (type == 'PATCH') {
            var count = 0;
            this.selectedData.sites.forEach((el: any) => {
              this.sitesData.map((parentelement: any) => {
                parentelement.children.map((childelement: any) => {
                  if (el.id == childelement.id) {
                    childelement.checked = true;
                    childelement.search = true;
                  }
                });
              });
            });
            this.sitesData.map((parentelement: any) => {
              parentelement.children.map((childelement: any) => {
                if (childelement.checked == true) {
                  count++;
                }
              });
              // if (count == parentelement.children.length) {
              parentelement['parent'] = {
                name: parentelement.parent,
                id: parentelement.children[0].accountId,
                search: true,
                checked: false,
              };
              // } else {
              //   parentelement['parent'] = {
              //     name: parentelement.parent,
              //     id: parentelement.children[0].accountId,
              //     search: true,
              //     checked: false,
              //   };
              // }
            });
            this.selectedData.accounts.forEach((element: any) => {
              if (element.isSelected == true) {
                if (element.children?.some((child: any) => child.checked)) {
                  this.sitesData.map((item: any) => {
                    if (item.parent.id == element.id) {
                      item.parent.checked = true;
                    }
                  });
                }
                this.sitesData = [...this.sitesData];
              }
            });

            if (this.currentSelectedTab == UserTypes.Supplier) {
              this.sitesData.forEach(({ parent, children }) => {
                // find any children that are checked === true
                const checkedChildren = children.filter(
                  (child) => child.checked
                );

                // if parent is checked, or if any child is checked...
                if (parent.checked || checkedChildren.length > 0) {
                  // …add the parent…
                  this.accountsArrayToPass.push(parent);
                  // …and add all those checked children
                  this.selectedSites.push(...checkedChildren);
                }
              });
            }
          } else if (type == 'GET') {
            this.sitesData.map((el: any, i: any) => {
              el.children.map((e: any) => {
                {
                  e.search = true;
                  e.checked = false;
                }
              });
              el['parent'] = {
                name: el.parent,
                id: el.children[0].accountId,
                search: true,
                checked: false,
              };
            });
          }

          // Ensure assigned label + dropdown values are ready before hiding loader
          // without showing validation message on initial drawer load.
          this.sitesDropdownChanged(this.sitesData, false);
          this.isLoadingAccountSites = false;
        }
        if (response.responseStatus != ResponseStatus.success) {
          this.isLoadingAccountSites = false;
        }
      }, () => {
        this.isLoadingAccountSites = false;
      });
  }


  agencyDropDownSelect(event: any) {
    this.selectedAgencyData = [];
    this.arrayOfAgency = [];
    event.forEach((element: any) => {
      if (element.checked == true) {
        this.selectedAgencyData.push({ id: element.id, name: element.name });
        this.arrayOfAgency.push(element.id);
      }
    });

    if (this.currentSelectedTab == UserTypes.Supplier) {

    } else {
      if (this.selectedData != null) {
        this.getAccountSitesByAgency(event, 'PATCH');
      } else {
        this.getAccountSitesByAgency(event, 'GET');
      }
    }
    // }
    this._fS.userForm.patchValue({
      agency: this.selectedAgencyData,
    });
    if (this.selectedAgencyData.length > 0) {
      this.showAgencysInvalidMessage = false;
    } else {
      this.showAgencysInvalidMessage = true;
    }
  }

  // supplierDropDownSelect(event: any) {
  //   this.selectedSupplierData = [];
  //   event.forEach((element: any) => {
  //     if (element.checked == true) {
  //       this.selectedSupplierData.push({ id: element.id, name: element.name });
  //     }
  //   });

  //    this._fS.userForm.patchValue({
  //     supplierReps: this.selectedSupplierData,
  //   });

  //   if (this.selectedSupplierData.length > 0 && !this.selectedData.localSupplier) {
  //     this.showSuppliersInvalidMessage = false;
  //   } else {
  //     this.showSuppliersInvalidMessage = true;
  //   }

  // }

  selectDataParentChildApi = [];
  getAccountSitesByAgency(event: any, type?: any) {
    this.isLoadingAccountSites = true;
    this._cpS
      .GetAccountSitesByAgency(this.arrayOfAgency)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.sitesData = response.result;

          // Mark hidden sites in the dropdown based on API status.
          // `gs-select` renders `child.name`, so we suffix the name here.
          this.sitesData?.forEach((parent: any) => {
            const isParentHidden = parent?.parentStatus === 0;
            if (isParentHidden && parent?.parent && !parent.parent.includes('(hidden)')) {
              parent.parent = `${parent.parent} (hidden)`;
            }

            parent?.children?.forEach((child: any) => {
              const isHidden =
                child?.status === 0;
              if (isHidden && child?.name && !child.name.includes('(hidden)')) {
                child.name = `${child.name} (hidden)`;
              }
            });
          });

          if (type == 'PATCH') {
            var count = 0;
            this.selectedData.sites.forEach((el: any) => {
              this.sitesData.map((parentelement: any) => {
                parentelement.children.map((childelement: any) => {
                  if (el.id == childelement.id) {
                    childelement.checked = true;
                    childelement.search = true;
                  }
                });
              });
            });

            this.sitesData.map((parentelement: any) => {
              parentelement.children.map((childelement: any) => {
                if (childelement.checked == true) {
                  count++;
                }
              });

              parentelement['parent'] = {
                name: parentelement.parent,
                id: parentelement.children[0].accountId,
                checked: false,
                search: true,
              };
            });
            this.selectedData.accounts.forEach((element: any) => {
              if (element.isSelected == true) {
                this.sitesData.map((item: any) => {
                  if (item.parent.id == element.id) {
                    item.parent['checked'] = true;
                  }
                });
              }
            });

            this.sitesData = [...this.sitesData];

            this.sitesDropdownChanged(this.sitesData, false);
          } else if (type == 'GET') {
            this.sitesData.map((el: any, i: any) => {
              el.children.map((e: any) => {
                {
                  e.search = true;
                  e.checked = false;
                }
              });
              el['parent'] = {
                name: el.parent,
                id: el.children[0].accountId,
                search: true,
                checked: false,
              };
            });

            this.sitesDropdownChanged(this.sitesData, false);
          }
          if (this.selectedSites.length > 0) {
            this.selectedSites.forEach((selectedEle) => {
              this.sitesData.forEach((siteEle) => {
                siteEle.children.forEach((siteChildEle) => {
                  if (selectedEle.id == siteChildEle.id) {
                    siteChildEle.checked = true;
                  }
                });
              });
            });
            const tempArr = this.accountsArrayToPass.filter(
              (x) => x.isSelected
            );
            if (tempArr.length) {
              tempArr.forEach((selectedEle) => {
                this.sitesData.forEach((siteEle) => {
                  if (selectedEle.id == siteEle.parent.id) {
                    siteEle.parent.checked = true;
                  }
                });
              });
            }
          }
        }
        this.isLoadingAccountSites = false;
      }, () => {
        this.isLoadingAccountSites = false;
      });
  }

  getAllSuppliersDropdown() {
    this.isLoadingSupplierReps = true;
    this._cpS.getAllSuppliersDropdown().subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.supplierAndRepsData = response.result;

        //filter data remove having children length 0
        this.supplierAndRepsData = this.supplierAndRepsData.filter((item: any) => item.children.length > 0);

        if (this.selectedData != null && this.selectedData.suppliers?.length > 0) {
          var count = 0;
          this.selectedData.reps.forEach((el: any) => {
            this.supplierAndRepsData.map((parentelement: any) => {
              parentelement.children.map((childelement: any) => {
                if (el.id == childelement.id) {
                  childelement.checked = true;
                  childelement.search = true;
                }
              });
            });
          });

          this.supplierAndRepsData.map((parentelement: any) => {
            parentelement.children.map((childelement: any) => {
              if (childelement.checked == true) {
                count++;
              }
            });

            parentelement['parent'] = {
              name: parentelement.parent,
              id: parentelement.children[0].supplierId,
              checked: false,
              search: true,
            };
          });

          this.selectedData.suppliers.forEach((element: any) => {
            if (element.isSelected == true) {
              this.supplierAndRepsData.map((item: any) => {
                if (item.parent.id == element.id) {
                  item.parent['checked'] = true;
                  item.parent.checked = true
                }
              });
            }
          });

          this.supplierAndRepsData = [...this.supplierAndRepsData];

          this.supplierDropdownChanged(this.supplierAndRepsData);
        } else {
          this.supplierAndRepsData.map((el: any, i: any) => {
            el.children.map((e: any) => {
              {
                e.search = true;
                e.checked = false;
              }
            });

            el['parent'] = {
              name: el.parent,
              id: el.children[0]?.supplierId,
              search: true,
              checked: false,
            };
          });
          // this.supplierAndRepsData = resultData;
          this.supplierAndRepsData = [...this.supplierAndRepsData];

          this.supplierDropdownChanged(this.supplierAndRepsData);
        }
        // if (this.selectedReps.length > 0) {
        //   this.selectedReps.forEach((selectedEle) => {
        //     this.supplierAndRepsData.forEach((siteEle) => {
        //       siteEle.children.forEach((siteChildEle) => {
        //         if (selectedEle.id == siteChildEle.id) {
        //           siteChildEle.checked = true;
        //         }
        //       });
        //     });
        //   });
        //   const tempArr = this.suppliersArrayToPass.filter(
        //     (x) => x.isSelected
        //   );
        //   if (tempArr.length) {
        //     tempArr.forEach((selectedEle) => {
        //       this.supplierAndRepsData.forEach((siteEle) => {
        //         if (selectedEle.id == siteEle.parent.id) {
        //           siteEle.parent.checked = true;
        //         }
        //       });
        //     });
        //   }
        // }
      }
      this.isLoadingSupplierReps = false;
    }, () => {
      this.isLoadingSupplierReps = false;
    });
  }

  sitesDropdownChanged(event: any, shouldValidate: boolean = true) {
    this.currentSelectedAccounts = event;
    this.selectedSites = [];
    this.accountsArrayToPass = [];

    event.forEach((element: any) => {
      if (element.parent.checked == true) {
        this.accountsArrayToPass.push({
          id: element.parent.id,
          accountName: element.parent.name,
          isSelected: true,
        });
      }
      element.children.forEach((child: any) => {
        if (child.checked == true) {
          this.selectedSites.push({ id: child.id, name: child.name });
          if (child.checked == true) {
            this.accountsArrayToPass.push({
              id: child.accountId,
              accountName: child.accountName,
              isSelected: element.parent.checked,
            });
          }
        }
      });
    });
    this.accountsArrayToPass = this.accountsArrayToPass.reduce((unique, o) => {
      if (!unique.some((obj: any) => obj.id === o.id)) {
        unique.push(o);
      }
      return unique;
    }, []);

    // this.selectedSites = this.selectedSites.filter(x=>x.)
    this._fS.userForm.patchValue({
      sites: this.selectedSites,
    });

    if (shouldValidate) {
      if (this.selectedSites.length > 0 || this.accountsArrayToPass.length > 0) {
        this.showSitesInvalidMessage = false;
      } else {
        this.showSitesInvalidMessage = true;
      }
    }
  }
  SBsitesDropdownChanged(event: any) {
    this.currentSelectedSBAccounts = event;
    this.sbSelectedSites = [];
    this.sbAccountsArrayToPass = [];

    event.forEach((element: any) => {
      if (element.parent.checked == true) {
        this.sbAccountsArrayToPass.push({
          id: element.parent.id,
          accountName: element.parent.name,
          isSelected: true,
        });
      }
      element.children.forEach((child: any) => {
        if (child.checked == true) {
          this.sbSelectedSites.push({ id: child.id, name: child.name });
          if (child.checked == true) {
            this.sbAccountsArrayToPass.push({
              id: child.accountId,
              accountName: child.accountName,
              isSelected: element.parent.checked,
            });
          }
        }
      });
    });
    this.sbAccountsArrayToPass = this.sbAccountsArrayToPass.reduce((unique, o) => {
      if (!unique.some((obj: any) => obj.id === o.id)) {
        unique.push(o);
      }
      return unique;
    }, []);

    this._fS.userForm.patchValue({
      sites: this.sbSelectedSites,
    });

    if (this.sbSelectedSites.length > 0 || this.sbAccountsArrayToPass.length > 0) {
      this.showSitesInvalidMessage = false;
    } else {
      this.showSitesInvalidMessage = true;
    }
  }

  supplierDropdownChanged(event: any) {
    this.currentSelectedRepsSupplier = event;
    this.selectedReps = [];
    this.suppliersArrayToPass = [];

    event.forEach((element: any) => {
      if (element.parent.checked == true) {
        this.suppliersArrayToPass.push({
          id: element.parent.id,
          name: element.parent.name,
          isSelected: true,
        });
      }
      element.children.forEach((child: any) => {
        if (child.checked == true) {
          this.selectedReps.push({ id: child.id, name: child.name });
          if (child.checked == true) {
            this.suppliersArrayToPass.push({
              id: child.supplierId,
              name: child.supplierName,
              isSelected: element.parent.checked,
            });
          }
        }
      });
    });

    this.suppliersArrayToPass = this.suppliersArrayToPass.reduce((unique, o) => {
      if (!unique.some((obj: any) => obj.id === o.id)) {
        unique.push(o);
      }
      return unique;
    }, []);

    this._fS.userForm.patchValue({
      supplierReps: this.selectedReps,
    });
    //  if (this.selectedReps.length > 0) {
    //   this.showRepsInvalidMessage = false;
    // } else {
    //   this.showRepsInvalidMessage = true;
    // }
  }

  //check If User Role Has Programs Permission

  async checkIfUserRoleHasProgramsPermission(checkedPrograms: any[]): Promise<boolean> {
    try {
      const response: any = await this._cpS.getRoleById(this._fS.userForm.value.role).toPromise();

      if (response.responseStatus === ResponseStatus.success) {
        const rolePermissions = response.result.permissions || [];
        const supplierPermissions = rolePermissions.filter(
          (permission: any) => permission.moduleType === 'Supplier'
        );
        const hasProgramViewPermission = supplierPermissions.some(
          (permission: any) =>
            permission.permissions[0].module === 'RetailProgram' &&
            permission.permissions[0].canView
        );

        if (hasProgramViewPermission) {
          this.hasPermissionToPrograms = true;
          return true;
        } else {
          if (checkedPrograms?.length) {
            this.hasPermissionToPrograms = false;
            this._cS.displayMessage(
              'warning',
              "The role for this user does not have access to the Programs page in PayBev. Please update the role or uncheck Retail Programs to continue."
            );
            return false;
          } else {
            this.hasPermissionToPrograms = true;
            return true;
          }
        }
      } else {
        console.error('Failed to fetch role permissions:', response.message);
        this.hasPermissionToPrograms = false;
        return false;
      }
    } catch (error) {
      console.error('Error fetching role permissions:', error);
      this.hasPermissionToPrograms = false;
      return false;
    }
  }

  //add or update button of drawer clicked
  async handleOk() {
    var sitesNames: any[] = [];
    var mergedSitesReps: any[] = [];
    var mergerAccountSuppliers: any[] = [];

    //enable role field
    this._fS.userForm.get('role')?.enable();

    //enable email field
    this._fS.userForm.get('emailAddress')?.enable();

    if (this.currentSelectedTab == UserTypes.Supplier) {
      this._fS.userForm.get('agency')?.clearValidators();
      this._fS.userForm.get('sites')?.clearValidators();

      this._fS.userForm.get('agency')?.updateValueAndValidity();
      this._fS.userForm.get('sites')?.updateValueAndValidity();
    }

    if (this._fS.userForm.valid) {
      // On the Supplier tab, sites and accounts come from the Supplier Bank tree only.
      const isSupplierTab = this.currentSelectedTab == UserTypes.Supplier;
      const sitesSource = isSupplierTab ? this.sbSelectedSites : this.selectedSites;
      const accountsSource = isSupplierTab ? this.sbAccountsArrayToPass : this.accountsArrayToPass;

      // Never persist dropdown display suffix — strip polluted `(hidden)` from payloads.
      sitesNames = sitesSource.map((site: any) => {
        return { id: site.id, name: stripHiddenNameSuffix(site.name) };
      });

      const accountsForPayload = accountsSource.map((account: AccountInfo) => ({
        ...account,
        accountName: stripHiddenNameSuffix(account.accountName),
      }));

      if (this.currentSelectedTab == UserTypes.Supplier) {
        mergedSitesReps = [...sitesNames].reduce((acc: any[], curr) => {
          if (!acc.some((item) => item.id === curr.id)) {
            acc.push(curr);
          }
          return acc;
        }, []);

        mergerAccountSuppliers = [...accountsForPayload].reduce(
          (acc: any[], curr) => {
            if (!acc.some((item) => item.id === curr.id)) {
              acc.push(curr);
            }
            return acc;
          },
          []
        );


        //find agency name with supplier from listofagencies
        const supplierAgency = this.listOfAgencies.find((agency: any) => agency.Name === 'Supplier');

        const supplierBankAgency = this.listOfAgencies.find((agency: any) => agency.Name === 'Supplier Bank');

        if (!this.selectedAgencyData.find((agency: any) => agency.id === supplierAgency._id))
          this.selectedAgencyData.push({ id: supplierAgency._id, name: supplierAgency.Name });

        //check if supplier bank accounts have length then add supplier bank agency is selectedAgencyData
        if (accountsSource.length > 0) {
          if (!this.selectedAgencyData.find((agency: any) => agency.id === supplierBankAgency._id))
            this.selectedAgencyData.push({ id: supplierBankAgency._id, name: supplierBankAgency.Name });
        }
      }

      // if (this.currentSelectedTab != UserTypes.Supplier  || this.hasPermissionToPrograms){

      const formValue = this._fS.userForm.value;
      var userBody: any = {
        Id: this.selectedData != null ? this.selectedData.id : '',
        firstName: formValue.firstName,
        lastName: formValue.lastName,
        email: formValue.emailAddress,
        role: formValue.role,
        agency: this.selectedAgencyData,
        twoFactorEnabled: formValue.is2FArequired,
        phoneNumber: formValue.phoneNumber,
        localSupplier: this.selectedData?.localSupplier,
        accounts:
          // this.currentSelectedTab == UserTypes.Supplier
          //   ? mergerAccountSuppliers
          // : 
          accountsForPayload,
        isForcePasswordChange: formValue.isChangePasswordRequired,
        sites:
          // this.currentSelectedTab == UserTypes.Supplier
          //   ? mergedSitesReps
          // : 
          sitesNames,
        isActive: formValue.isUserActive,
        suppliers:
          this.suppliersArrayToPass,
        reps: this.selectedReps
      };

      if (this.currentSelectedTab != UserTypes.Supplier) {
        const allParentsChecked = this.sitesData.every(
          (item) => item.parent?.checked === true
        );

        userBody['accessAllAccounts'] =
          this.accountsArrayToPass.length == this.sitesData.length &&
            allParentsChecked
            ? true
            : false;
      } else {
        const allSupplierBankParentsChecked = this.supplierBankSitesData.every(
          (item) => item.parent?.checked === true
        );

        const allSuppliersChecked = this.supplierAndRepsData.every(
          (item) => item.parent.checked === true
        );

        userBody['accessAllAccounts'] =
          allSupplierBankParentsChecked
            ? true
            : false;

        userBody['accessAllSuppliers'] = allSuppliersChecked
          ? true
          : false;
      }

      if (this.selectedAgencyData.length == this.listOfAgencies.length) {
        userBody['accessAllAgency'] =
          this.currentSelectedTab == UserTypes.Supplier ? false : true;
      }

      //add or edit user data
      if (this.selectedData == null) {
        this.addUserData(userBody);
      } else {
        this.editUserData(userBody);
      }
      // }
      // else{

      // }
    } else {
      //to fire validations on invalid fields
      Object.values(this._fS.userForm.controls).forEach((control: any) => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
      if (this.selectedSites?.length == 0) {
        this.showSitesInvalidMessage = true;
      }

      if (this.selectedAgencyData?.length == 0) {
        this.showAgencysInvalidMessage = true;
      }

      if (this.selectedSupplierData?.length == 0 && !this.selectedData?.localSupplier) {
        this.showSuppliersInvalidMessage = true;
      }
    }
  }

  editUserData(userBody: any) {
    this.isLoadingOne = true;
    this._cpS.EditUser(userBody).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this._cS.displayMessage('success', response.message);
          //hide user drawer
          this.isVisibleUserDrawer = false;

          this.hideUserDrawer.emit({
            hide: this.isVisibleUserDrawer,
            data: response.result,
          });
          this.isLoadingOne = false;
        } else {
          this._cS.displayMessage('error', response.message);
          this.isLoadingOne = false;
        }
      },
      (error: any) => {
        // this._cs.displayMessage('error', error.message);
        this.isLoadingOne = false;
      }
    );
  }

  //add or update date on buttton click
  addUserData(userBody: any) {
    this.isLoadingOne = true;
    this._cpS.createUser(userBody).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this._cS.displayMessage('success', response.message);
          //hide user drawer
          this.isVisibleUserDrawer = false;
          this.hideUserDrawer.emit({
            hide: this.isVisibleUserDrawer,
            data: response.result,
          });
          this.isLoadingOne = false;
        } else {
          // this._fS.userForm.controls['emailAddress'].disable();

          this._cS.displayMessage('error', response.message);
          this.isLoadingOne = false;
        }
      },
      (error: any) => {
        // this._cs.displayMessage('error', error.message);
        this.isLoadingOne = false;
      }
    );
  }

  //Code added by Dev for Retail
  getRetailProgramForSupplier() {
    this._cpS.getRetailProgramForSupplier().subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.retailProgramsList = [...response.result];

        if (
          this.selectedData != null &&
          this.selectedData.retailPrograms != null
        ) {
          const checkedIds = new Set(
            this.selectedData.retailPrograms.map((p) => p.id)
          );

          // 2) Walk `retailsProgramList` and flip on `isChecked` whenever the ID is in that Set
          this.retailProgramsList.forEach((program) => {
            if (checkedIds.has(program.id)) {
              program['isChecked'] = true;
            }
          });
        }
      }
    });
  }

  getAllAgencys() {
    this._iS.GetAgencyDropdownList().subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.listOfAgencies = response.result;
        this.listOfAgencies.map((el: any, i: any) => {
          el['id'] = el._id;
          el['name'] = el.Name;
          el['checked'] = false;
        });

        if (this.selectedData != null) {
          if (
            this.selectedData.agency.length > 0 &&
            this.selectedData.agency[0].name != null &&
            this.selectedData.agency[0].id == 'All'
          ) {
            this.selectedData.agency = this.listOfAgencies.map(
              (element: any) => {
                return { id: element._id, name: element.Name };
              }
            );
          }
          this.listOfAgencies.forEach((el: any) => {
            this.selectedData.agency.map((element: any) => {
              if (el.id == element.id) {
                el.checked = true;
                el.search = true;
              }
            });
          });
          this.agencyDropDownSelect(this.listOfAgencies);
        }
      }
    });
  }
}
